import React from "react";
import {
  Modal,
  ModalProps,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";

interface Props {
  visible: boolean;
  onClose: () => void;
  animationType?: "fade" | "none" | "slide";
  children: JSX.Element | JSX.Element[];
  containerStyle?: ViewStyle;
  backdropStyle?: ViewStyle;
}

const RXModal = (props: Props & ModalProps) => {
  const {
    onClose = () => {},
    animationType = "fade",
    children,
    containerStyle = {},
    backdropStyle = {},
  } = props;
  const close = () => {
    onClose();
  };

  return (
    <Modal
      animationType={animationType}
      transparent={true}
      onRequestClose={close}
      {...props}
    >
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          ...containerStyle,
        }}
      >
        <TouchableWithoutFeedback onPress={close}>
          <View
            style={[
              StyleSheet.absoluteFill,
              {
                backgroundColor: "rgba(0,0,0,0.7)",
                ...backdropStyle,
              },
            ]}
          />
        </TouchableWithoutFeedback>
        <View>{children}</View>
      </View>
    </Modal>
  );
};

export default RXModal;
